import { render, staticRenderFns } from "./InfoMobileMenu.vue?vue&type=template&id=5a32a82c&scoped=true&"
import script from "./InfoMobileMenu.vue?vue&type=script&setup=true&lang=ts&"
export * from "./InfoMobileMenu.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./InfoMobileMenu.vue?vue&type=style&index=0&id=5a32a82c&scoped=true&lang=scss&"
import style1 from "./InfoMobileMenu.vue?vue&type=style&index=1&id=5a32a82c&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a32a82c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a32a82c')) {
      api.createRecord('5a32a82c', component.options)
    } else {
      api.reload('5a32a82c', component.options)
    }
    module.hot.accept("./InfoMobileMenu.vue?vue&type=template&id=5a32a82c&scoped=true&", function () {
      api.rerender('5a32a82c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/info-pages/InfoMobileMenu.vue"
export default component.exports